import React, { useState, useEffect, useRef } from 'react';
import MapWorkspace from './map_workspace';
import { BASE_URL, CACHED_BASE_URL } from '../../../commonConfig/ApiConfig'
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import MapLegend from './MapLegend';
import CircleLegend from './CircleLegend';
import MarkerLegend from './markerlegend';
import ExportDropdown from './export';
import SingleIndicatorLegend from './extralegend';
import SaveCharts from '../map/mapConfig/SaveChart';
import WorkspaceSidePanel from "components/cmn_workspace/workspace_button";
import WorkspaceButton from "components/pages/workspacebtn/workspacebtn";
import { useSelector, useDispatch } from 'react-redux';
import { setWorkspaceLoaded } from 'store/workspaceSlice';

function UlgWorkspacePage() {
  const [geoJsonData, setGeoJsonData] = useState(null);
  const [statesData, setStatesData] = useState(null);
  const [selectedPalette, setSelectedPalette] = useState(['#FFFFFF', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#F0E68C', 'red', '#00FFFF']);
  const [showIndicator3, setShowIndicator3] = useState(true);
  const [exportdata, setExportData] = useState(null);
  const [showIndicator4, setShowIndicator4] = useState(true);
  const [showIndicator5, setShowIndicator5] = useState(true);
  const [showColorLayer, setShowColorLayer] = useState(true); // Default to true to show the all layers initially
  const [showPatternLayer, setShowPatternLayer] = useState(true);
  const [showPieChart, setShowPieChart] = useState(true); // New state for pie chart visibility
  const [showController, setShowController] = useState(true); // New state for controller visibility
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { formattedPayload, payload, reduxPayload } = location.state || {};
  const setMapConfigData = formattedPayload;

  const [colorBreaks, setColorBreaks] = useState([]);
  const [indicatorBreaks, setIndicatorBreaks] = useState({});

  const [ulbmapbreak, setUlbMapBreak] = useState([]);
    //============== Workspace panel ==============
    const selectedIndicators = useSelector(state => state.workspace.selectedIndicators);
    const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures);
    const [showWorkspace, setShowWorkspace] = useState(true);
    const handleVisualize = (selectedIndicators) => {
      navigate('/mapconfig', { state: { selectedIndicators, selectedMapFeatures } });
    };
    const handleSaveSuccess = (workspaceData) => {
      alert(`Workspace "${workspaceData.name}" saved successfully!`);
  
      // Always load the saved workspace as current
      if (workspaceData.id && workspaceData.name) {
        setTimeout(() => {
          dispatch(setWorkspaceLoaded({
            id: workspaceData.id,
            name: workspaceData.name,
            workspace: workspaceData
          }));
        }, 100);
      }
    };

  useEffect(() => {
    const fetchIndicatorValues = async () => {
      try {
        const res = await axios.post(`${BASE_URL}indicators/map/ulg`, payload);
        setExportData(res.data);
        setStatesData(res.data.indicator_values);
        if (res.data.geojson) {
          setGeoJsonData(res.data.geojson);
        } else {
          // const localpayload={
          //   lgd_code: payload.lgd_code,
          //   geo_level_code: payload.lgd_geo_level,
          // }
          // const geo = await axios.post(`${BASE_URL}locations/geojson`, localpayload);
          // setGeoJsonData(geo.data.geojson);
          const geo = await axios.get(`${CACHED_BASE_URL}locations/s-geojson`, {
            params: {
              lgd_code: payload.lgd_code,
              geo_level_code: payload.lgd_geo_level,
            },
          });

          setGeoJsonData(geo.data.geojson);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    if (formattedPayload) {
      fetchIndicatorValues();
    }
  }, [formattedPayload, payload]);
  const indicator3LayerRef = useRef(null);
  const indicator4LayerRef = useRef(null);
  const indicator5LayerRef = useRef(null);


  const locationName = formattedPayload?.selectedLocation?.label || "Map Workspace";
  const location_level = formattedPayload?.selectedLocation?.geo_level;

  const levelMap = {
    1: 'National',
    2: 'State',
    3: 'District',
    4: 'ULB',
  };
  const displayLevel = levelMap[location_level]
  const indicators = setMapConfigData?.indicators || [];

  const getIndicatorCode = (indicator) => {
    const i_code = indicator?.code;
    const si_code = indicator?.subIndicator?.code;

    // If subIndicator exists → `${i_code}#${i_code}_${si_code}`
    // Otherwise → `${i_code}#`
    if (!i_code) return '';
    return si_code ? `${i_code}#${si_code}` : `${i_code}#`;
  };

  // Safely map the first 3 indicators
  const indicator_3_code = getIndicatorCode(indicators[0]);
  const indicator_4_code = getIndicatorCode(indicators[1]);
  const indicator_5_code = getIndicatorCode(indicators[2]);
  const patternIndicator = setMapConfigData?.patternIndicator;
  const pi_code = patternIndicator?.code;
  const psi_code = patternIndicator?.subIndicator?.code;

  const indicator_2_code = psi_code
    ? `${pi_code}#${psi_code}`
    : `${pi_code}#`;

  //const exportRef = useRef(null);
  const exportRef = React.useRef();
  const mapRef = React.useRef();
  return (
    <>
    <WorkspaceButton
        showWorkspace={showWorkspace}
        setShowWorkspace={setShowWorkspace}
      />
      <WorkspaceSidePanel showWorkspace={showWorkspace}
        setShowWorkspace={setShowWorkspace}
        onVisualize={handleVisualize}
        onSaveSuccess={handleSaveSuccess} />
    <div className="container-fluid" style={{ paddingTop: '6px' }}>
      <div className="row"//style={{ height: '100vh' }}
      >
        {/* Left Column - Map (70%) */}
        <div className="col-md-8 mt-2" ref={exportRef} id="exportDiv"  >
          <div className="mt-2">
            <div className="p-2 bg-white border-bottom shadow-sm">
              {location_level && (
                <div className="text-start">
                  <h2 className="fs-4 fw-bold text-dark mb-1">
                    {locationName}
                  </h2>
                  <p className="fs-0 text-secondary mb-0">
                    {displayLevel}
                  </p>
                </div>
              )}
            </div>
            <div className="mt-2" style={{ height: '80vh', maxHeight: '900px' }}>
              <MapWorkspace
                mapRef={mapRef}
                geoJsonData={geoJsonData}
                statesData={statesData}
                selectedPalette={selectedPalette}
                indicator3LayerRef={indicator3LayerRef}
                indicator4LayerRef={indicator4LayerRef}
                indicator5LayerRef={indicator5LayerRef}
                showIndicator3={showIndicator3}
                showIndicator4={showIndicator4}
                showIndicator5={showIndicator5}
                setSelectedPalette={setSelectedPalette}
                setGeoJsonData={setGeoJsonData}
                setUlbMapBreak={setUlbMapBreak}
                setStatesData={setStatesData}
                setShowIndicator3={setShowIndicator3}
                setShowIndicator4={setShowIndicator4}
                setShowIndicator5={setShowIndicator5}
                showColorLayer={showColorLayer}
                setShowColorLayer={setShowColorLayer}
                showPatternLayer={showPatternLayer}
                setShowPatternLayer={setShowPatternLayer}
                setMapConfigData={setMapConfigData}
                onBreaksCalculated={setColorBreaks}
                onIndicatorBreaksCalculated={setIndicatorBreaks}
                showPieChart={showPieChart} // Pass new prop
                setShowPieChart={setShowPieChart} // Pass new prop
                showController={showController} // Pass new prop
              />
            </div>
            {/* Legends directly in WorkspacePage */}
            <div style={{ marginTop: '10px', display: 'flex' }}>

              <SingleIndicatorLegend setMapConfigData={setMapConfigData} breaks={ulbmapbreak} colors={selectedPalette} />
              {/* {geoJsonData && statesData && colorBreaks.length > 0 && (
                <MapLegend
                  colors={selectedPalette}
                  breaks={colorBreaks}
                  showPatternLayer={showPatternLayer}
                  showColorLayer={showColorLayer}
                  setMapConfigData={setMapConfigData}
                  patternBreaks={
                    indicatorBreaks[indicator_2_code] || []
                  }
                />
              )}
              {(showIndicator3 || showIndicator4 || showIndicator5) && setMapConfigData?.chartType?.toLowerCase() === 'bubble' &&
                Object.keys(indicatorBreaks).length > 0 && (
                  <CircleLegend
                    showIndicator3={showIndicator3}
                    showIndicator4={showIndicator4}
                    showIndicator5={showIndicator5}
                    indicator3Breaks={
                      indicatorBreaks[indicator_3_code] || []
                    }
                    indicator4Breaks={
                      indicatorBreaks[indicator_4_code] || []
                    }
                    indicator5Breaks={
                      indicatorBreaks[indicator_5_code] || []
                    }
                    colors={selectedPalette}
                    setMapConfigData={setMapConfigData}
                  />
                )}
              {(showIndicator3 || showIndicator4 || showIndicator5) && setMapConfigData?.chartType?.toLowerCase() === 'marker' &&
                Object.keys(indicatorBreaks).length > 0 && (
                  <MarkerLegend
                    showIndicator3={showIndicator3}
                    showIndicator4={showIndicator4}
                    showIndicator5={showIndicator5}
                    indicator3Breaks={
                      indicatorBreaks[indicator_3_code] || []
                    }
                    indicator4Breaks={
                      indicatorBreaks[indicator_4_code] || []
                    }
                    indicator5Breaks={
                      indicatorBreaks[indicator_5_code] || []
                    }
                    colors={selectedPalette}
                    setMapConfigData={setMapConfigData}
                  />
                )} */}
            </div>
          </div>

        </div>

        {/* Right side: Config Summary */}
        <div className="col-md-4 bg-light p-3" style={{ overflowY: 'auto' }}>
          <div className="row">

            {/* Selected Locations */}
            {/* <div className="col-md-12 mb-3">
      <h5 className="f-14 fw-bold">Selected Locations</h5>
      <ul className="list-group list-group-flush mb-2">
        <li className="list-group-item">India</li> 
        {formattedPayload?.selectedLocations?.map((loc, idx) => (
          <li key={`loc-${idx}`} className="list-group-item">
            <div className="fw-bold f-13">{loc.lgd_name}</div>
            <div className="text-muted small">Geo Level: {loc.geo_level}</div>
          </li>
        ))}
      </ul>
    </div> */}

            {/* Selected Indicators */}
            <div className="col-md-12">
              <h5 className="f-14 fw-bold">Map Indicators</h5>
              {(() => {
                const indicatorCodes = [
                  formattedPayload?.indicator?.code,
                  ...(formattedPayload?.indicators || []).map(ind => ind.code)
                ].filter(Boolean);

                const uniqueCodes = [...new Set(indicatorCodes)];
                const indicators = uniqueCodes
                  .map(code => formattedPayload?.indicator_info?.[code])
                  .filter(Boolean);

                return indicators.length === 0 ? (
                  <p className="text-muted">No indicators selected</p>
                ) : (
                  <ul className="list-group mb-3">
                    {indicators.map((ind) => (
                      <li key={ind.indicator_code} className="list-group-item">
                        <div className="fw-bold text-primary" style={{ fontSize: "13px" }}>
                          {ind.indicator_name && (
                            <>
                              <span>{ind.indicator_name}</span>
                              {ind.dataset_name && <span> ({ind.dataset_name})</span>}
                            </>
                          )}

                          {ind.indicator_date && ind.indicator_date !== "NA" && (
                            <>
                              {" | "}
                              <span
                                style={{
                                  backgroundColor: "#2c7ce5",
                                  color: "#fff",
                                  padding: "0 6px",
                                  borderRadius: "4px",
                                  fontSize: "12px",
                                }}
                              >
                                {ind.indicator_date}
                              </span>
                            </>
                          )}

                          {ind.agency_name && ind.agency_name !== "NA" && (
                            <>
                              {" | "}
                              <span>{ind.agency_name}</span>
                            </>
                          )}

                          {/* {Array.isArray(ind.geo_levels) && ind.geo_levels.length > 0 && (
                            <>
                              {" | "}
                              <span>{ind.geo_levels.join(", ")}</span>
                            </>
                          )} */}
                        </div>
                        <div className="text-muted small">
                          {/* Available Geo Levels Section */}
                          {ind.geo_levels && ind.geo_levels.length > 0 && (
                            <div className="mt-1 mb-1">
                              <span className="me-2" style={{ fontSize: "0.875rem" }}>Available Geo Levels:</span>
                              {ind.geo_levels.map((level, idx) => (
                                <span
                                  key={idx}
                                  style={{
                                    backgroundColor: "#28a745",
                                    color: "#fff",
                                    borderRadius: "0.25rem",
                                    padding: "0.2rem 0.5rem",
                                    marginRight: "0.3rem",
                                    fontSize: "0.75rem",
                                    display: "inline-block"
                                  }}
                                >
                                  {level}
                                </span>
                              ))}
                            </div>
                          )}
                          {[ind.sector_name, ind.sub_sector_name, ind.sub_sub_sector_name]
                            .filter(val => val && val !== "NA")
                            .join(" | ")}
                        </div>
                      </li>
                    ))}
                  </ul>
                );
              })()}
            </div>
            <div className="col-md-12 mb-3">
              <button
                className="btn btn-primary w-100 mb-2"
                onClick={() => navigate('/mapconfig', { state: formattedPayload })}
              >
                Go Back to Map Configuration
              </button>
            </div>
            <div className='d-flex justify-content-between'>
              <ExportDropdown showController={showController} setShowController={setShowController} exportRef={exportRef} mapRef={mapRef} apiResponse={exportdata} visualizationConfig={formattedPayload} />
              <SaveCharts className="mt-3" payload={payload} formattedPayload={formattedPayload} path="/map-visualization" reduxPayload={reduxPayload} />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default UlgWorkspacePage;